import type {
  YachtCategory,
  YachtViewerState,
  YachtViewerTurnState,
} from "@cloudnest/yacht-engine";
import { MobileYachtScreen } from "../mobile/MobileYachtScreen";

export function DesktopYachtScreen({
  state,
  myPlayerId,
  readOnly,
  onRoll,
  onToggleHold,
  onConfirmScore,
  onLeaveGame,
}: {
  readonly state: YachtViewerState;
  readonly myPlayerId: string | null;
  readonly readOnly: boolean;
  readonly onRoll: (slot: YachtViewerTurnState) => void;
  readonly onToggleHold: (slot: YachtViewerTurnState, dieIndex: number) => void;
  readonly onConfirmScore: (
    slot: YachtViewerTurnState,
    category: YachtCategory,
  ) => void;
  readonly onLeaveGame: () => void;
}) {
  return (
    <MobileYachtScreen
      state={state}
      myPlayerId={myPlayerId}
      readOnly={readOnly}
      onRoll={onRoll}
      onToggleHold={onToggleHold}
      onConfirmScore={onConfirmScore}
      onLeaveGame={onLeaveGame}
    />
  );
}
